import { getPropertyValue } from 'framework-listing-lib/utils/crmObject';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { DialogHeader } from 'foundations-components/transitional/components/DialogHeader';
import { DialogBody } from 'foundations-components/transitional/components/DialogBody';
import { DialogFooter } from 'foundations-components/transitional/components/DialogFooter';
import { List } from 'foundations-components/transitional/components/List';
import { ScrollContainer } from 'foundations-components/transitional/components/ScrollContainer';
import { DialogCloseButton } from 'foundations-components/transitional/components/DialogCloseButton';
import { Modal } from 'foundations-components/transitional/components/Modal';
import { H2 } from 'foundations-components/transitional/components/H2';
import { PROPERTIES } from 'FormsUI/components/dashboard/frameworkTable/constants';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SelectedForm = crmObject => {
  const name = getPropertyValue(crmObject, PROPERTIES.NAME);
  const formId = getPropertyValue(crmObject, PROPERTIES.FORM_ID);
  return /*#__PURE__*/_jsx("span", {
    children: name
  }, formId);
};
const DeleteDialog = ({
  handleConfirm,
  handleReject,
  selectedObjects,
  disableConfirm
}) => /*#__PURE__*/_jsxs(Modal, {
  use: "danger",
  children: [/*#__PURE__*/_jsxs(DialogHeader, {
    children: [/*#__PURE__*/_jsx(DialogCloseButton, {
      onClick: handleReject
    }), /*#__PURE__*/_jsx(H2, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "multiFormDeleteDialog.header",
        options: {
          count: selectedObjects.length
        }
      })
    })]
  }), /*#__PURE__*/_jsxs(DialogBody, {
    children: [/*#__PURE__*/_jsx(FormattedMessage, {
      message: "multiFormDeleteDialog.body"
    }), /*#__PURE__*/_jsx(ScrollContainer, {
      "data-info": "deleted-forms-listing",
      maxHeight: 300,
      marginBlockStart: "500",
      children: /*#__PURE__*/_jsx(List, {
        styled: true,
        wrapChildren: true,
        children: selectedObjects.map(SelectedForm)
      })
    })]
  }), /*#__PURE__*/_jsxs(DialogFooter, {
    children: [/*#__PURE__*/_jsx(Button, {
      use: "danger",
      onClick: handleConfirm,
      disabled: disableConfirm,
      "data-action": "delete",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "multiFormDeleteDialog.delete"
      })
    }), /*#__PURE__*/_jsx(Button, {
      use: "tertiary-light",
      onClick: handleReject,
      disabled: disableConfirm,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "cancel"
      })
    })]
  })]
});
export default DeleteDialog;